import React from "react";
import { NewChat, NewChatWrap } from "./components";
import { usePostNewChat } from "./hooks";

const ChatCreateForm = () => (
  <NewChatWrap Content={NewChat} useHook={usePostNewChat} />
);

export default ChatCreateForm;
